<template>
	<div class="detail-dialog">
		<el-drawer :title="title" :visible.sync="isShow" :direction="direction" :before-close="handleClose" size="1400px">
			<div class="detail-dialog-main">
				<div class="list-table-item">
					<div style="width: 80px;">
						<img class="channel-icon" :src="getChannelIcon(detail)" width="40" height="40" >
					</div>
					<div class="list-table-item__left">
						<div class="flex flex-column-center">
							<img class="margin-right_8" v-if="detail.isRecommend == 1" src="@/assets/img/client/check/RecommendIcon.png" width="16" height="16">
							<div class="flex" style="align-items: center;">
								<div class="channel-name-text">{{ detail.channelName }} </div>
								<div class="tag-mode">{{getMode(detail)}}</div>
								<div class="tag-tax" v-if="detail.isIncludedTax==1" >包税</div>
							</div>
						</div>
						<div class="flex margin-top_16" >
							<div class="flex flex-1 flex-column-center">
								<div class="flex flex-column-center">
									<span class="text2">{{ `${GetStartAddress(detail)}` }} | 中国</span>
								</div>
								<div class="flex flex-column-center">
									<img src="@/assets/img/client/check/DetailLine.png" alt="air" width="144" height="33">
								</div>
								<div class="flex flex-column-center">
									<span class="text2">{{ `${GetDestAddress(detail)}` }} | {{ detail.destinationCountryNameCn }}</span>
								</div>
							</div>
						</div>
						<div class="flex margin-top_16 margin-bottom_16" >
							<div class="text1">预估时效（发货-签收）：<span class="text2">{{detail.workDays}} 自然日</span></div>
						</div>
						<div class="list-table-item__left-cargoTypeNames" :title="detail.cargoTypeNames">
							<div class="text1">可接货物：<span class="text2">{{detail.cargoTypeNames}}</span></div>
						</div>
					</div>
					<div class="list-table-item__center">
						<div class="flex" style="flex-direction: column;align-items: start;padding:10px 15px;border-left: 1px solid #E1E1E1;">
							<div>
								<div v-if="detail.totalAmount>0" class="padding-bottom_5 text4">￥{{ detail.totalAmount }}</div>
								<div v-else class="padding-bottom_5 text1">单询</div>
							</div>
							<div class="flex flex-row-center">
								<div class="text2">单价 <span class="text3">￥{{(detail.totalAmount/detail.chargeWeight).toFixed(2)}}/{{getUnit(detail.countMode)}}</span></div>
								<div class="text2 margin-left_24"> 计费重 <span class="text3">{{detail.chargeWeight}}{{getUnit(detail.countMode)}}</span></div>
							</div>
						</div>
					</div>
					<div class="list-table-item__toOrder">
						<button class="choose-btn" @click="toOrder(detail)"><span>立即下单</span></button>
					</div>
				</div>
				<table class="detail-table" >
					<thead>
						<tr class="detail-table-tr" style="background: #F5F6F9;">
							<th class="detail-table-td">费用代码</th>
							<th class="detail-table-td">费用名称</th>
							<th class="detail-table-td">费用说明</th>
							<th class="detail-table-td">单位</th>
							<th class="detail-table-td">单价</th>
							<th class="detail-table-td">费用</th>
						</tr>
					</thead>
					<tbody>
						<tr class="detail-table-tr" v-if="detail.pickupAmount > 0" >
							<td class="detail-table-td">
								<span class="text">PICKUP</span>
							</td>
							<td class="detail-table-td">
								<span class="text">Pickup Fee</span>
							</td>
							<td class="detail-table-td">
								<span class="text">Pickup Fee</span>
							</td>
							<td class="detail-table-td">
								<span class="text">{{ detail.pickupChargeWeight }}</span>
							</td>
							<td class="detail-table-td">
								<span class="text">CNY ￥{{ (detail.pickupAmount/item.pickupChargeWeight).toFixed(3) }}</span>
							</td>
							<td class="detail-table-td">
								<span class="text1">CNY ￥{{ detail.pickupAmount.toFixed(2) }}</span>
							</td>
						</tr>
						<tr class="detail-table-tr" v-if="detail.startLiftgateAmount > 0" >
							<td class="detail-table-td">
								<span class="text">LIFT</span>
							</td>
							<td class="detail-table-td">
								<span class="text">Lift Gate Charge</span>
							</td>
							<td class="detail-table-td">
								<span class="text">Flat Fee</span>
							</td>
							<td class="detail-table-td">
								<span class="text">1</span>
							</td>
							<td class="detail-table-td">
								<span class="text">CNY ￥{{ detail.startLiftgateAmount }}</span>
							</td>
							<td class="detail-table-td">
								<span class="text1">CNY ￥{{ detail.startLiftgateAmount }}</span>
							</td>
						</tr>
						<tr class="detail-table-tr" v-for="(item,index) in detail.feeList" :key="index" >
							<td class="detail-table-td">
								<span class="text">{{ item.code }}</span>
							</td>
							<td class="detail-table-td">
								<span class="text">{{ item.name }}</span>
							</td>
							<td class="detail-table-td">
								<span class="text">{{ item.comment }}</span>
							</td>
							<td class="detail-table-td">
								<span class="text">{{ item.units }}</span>
							</td>
							<td class="detail-table-td">
								<span v-if="item.amount>0" class="text">CNY ￥{{ item.unitPrice.toFixed(2) }}</span>
								<span v-else class="text">单询</span>
							</td>
							<td class="detail-table-td">
								<span v-if="item.amount>0" class="text1">CNY ￥{{ item.amount }}</span>
								<span v-else class="text1">单询</span>
							</td>
						</tr>
						<tr class="detail-table-tr" v-if="detail.bondAmount > 0" >
							<td class="detail-table-td">
								<span class="text">{{ detail.bondType === 1 ?'Single Entry Bond(based on goods value of USD' + detail.GoodsValue + ')' : 'Annual bond' }}</span>
							</td>
							<td class="detail-table-td">
								<span class="text">-</span>
							</td>
							<td class="detail-table-td">
								<span class="text">-</span>
							</td>
							<td class="detail-table-td">
								<span class="text">1</span>
							</td>
							<td class="detail-table-td">
								<span class="text">CNY ￥{{ detail.bondAmount.toFixed(2) }}</span>
							</td>
							<td class="detail-table-td">
								<span class="text1">CNY ￥{{ detail.bondAmount.toFixed(2) }}</span>
							</td>
						</tr>
						<tr class="detail-table-tr" v-if="detail.destLiftgateAmount > 0" >
							<td class="detail-table-td">
								<span class="text">LIFT</span>
							</td>
							<td class="detail-table-td">
								<span class="text">Lift Gate Charge</span>
							</td>
							<td class="detail-table-td">
								<span class="text">Flat Fee</span>
							</td>
							<td class="detail-table-td">
								<span class="text">1</span>
							</td>
							<td class="detail-table-td">
								<span class="text">CNY ￥{{ detail.destLiftgateAmount }}</span>
							</td>
							<td class="detail-table-td">
								<span class="text1">CNY ￥{{ detail.destLiftgateAmount }}</span>
							</td>
						</tr>
						<tr class="detail-table-tr" v-if="detail.ISFBondAmount > 0" >
							<td class="detail-table-td">
								<span class="text">ISF Bond</span>
							</td>
							<td class="detail-table-td">
								<span class="text">ISF Bond</span>
							</td>
							<td class="detail-table-td">
								<span class="text">ISF Bond</span>
							</td>
							<td class="detail-table-td">
								<span class="text">1</span>
							</td>
							<td class="detail-table-td">
								<span class="text">CNY ￥{{ detail.ISFBondAmount }}</span>
							</td>
							<td class="detail-table-td">
								<span class="text1">CNY ￥{{ detail.ISFBondAmount }}</span>
							</td>
						</tr>
						<tr class="detail-table-tr" v-if="detail.insuranceAmount > 0" >
							<td class="detail-table-td">
								<span class="text">保险费 (货值：${{ detail.GoodsValue }})</span>
							</td>
							<td class="detail-table-td">
								<span class="text">-</span>
							</td>
							<td class="detail-table-td">
								<span class="text">-</span>
							</td>
							<td class="detail-table-td">
								<span class="text">1</span>
							</td>
							<td class="detail-table-td">
								<span class="text">CNY ￥{{ detail.insuranceAmount }}</span>
							</td>
							<td class="detail-table-td">
								<span class="text1">CNY ￥{{ detail.insuranceAmount }}</span>
							</td>
						</tr>
					</tbody>
				</table>
				<div class="detail-table-total" >
					<div class="margin-top_8">
						<span v-if="detail.totalAmount>0" class="text1">小计: CNY ￥{{ detail.totalAmount }}</span>
						<span v-else class="text1">小计: 单询</span>
					</div>
					<div >
						<span v-if="detail.totalAmount>0" class="text2">总计: <span class="text3">CNY ￥{{ detail.totalAmount }}</span></span>
						<span v-else class="text2">总计: 单询</span>
					</div>
				</div>
				<!-- <div class="extra-charge-standards">
					<div class="extra-charge-standards-title padding-bottom_10 padding-top_10">
						<span>额外附加费标准</span>
						<span class="margin-left_24">货物入仓后如产生如下费用，将按实际收取</span>
					</div>
					<table class="extra-charge-standards-table" border >
						<thead>
							<tr class="extra-charge-standards-table-tr">
								<th class="extra-charge-standards-table-td">费用名称</th>
								<th class="extra-charge-standards-table-td">收费标准</th>
								<th class="extra-charge-standards-table-td">费用说明</th>
							</tr>
						</thead>
						<tbody>
							<tr class="extra-charge-standards-table-tr">
								<td class="extra-charge-standards-table-td">超长附加费</td>
								<td class="extra-charge-standards-table-td">CNY 240/件</td>
								<td class="extra-charge-standards-table-td">最长边长度≥ 120CM ≤243CM或者任意其他两边≥75CM ，加收240元/每件</td>
							</tr>
							<tr class="extra-charge-standards-table-tr">
								<td class="extra-charge-standards-table-td">超围长附加费</td>
								<td class="extra-charge-standards-table-td">CNY 230/件</td>
								<td class="extra-charge-standards-table-td">260CM≤围长≤320CM，需加收230元/每件</td>
							</tr>
							<tr class="extra-charge-standards-table-tr">
								<td class="extra-charge-standards-table-td">超重附加费</td>
								<td class="extra-charge-standards-table-td">CNY 950/件</td>
								<td class="extra-charge-standards-table-td">41KG≤单件实重≤65KG RMB950/件</td>
							</tr>
						</tbody>
					</table>
				</div> -->
				<div v-if="!!detail.detailList && detail.detailList.length > 0" class="card-remarks">
					<div v-for="( item, index ) in detail.detailList " :key="index" >
						<div class="card-remarks-title" >
							<div></div>
							<p>{{ item.moduleName }}</p>
						</div>
						<div class="margin-top_10">
							{{ item.content }}
						</div>
					</div>
				</div>
			</div>
		</el-drawer>
		<ConfirmOrder v-show="confirmOrderVisible" ref="ConfirmOrder" @close="closeConfirm" style="z-index: 99999;" />
	</div>
</template>

<script>
	import {
		CreateFBAOrder,
		CreateAirOrder,
		CreateExpOrder,
		CreateSeaOrder
	} from '@/api/order.js'
  	import { getDictionaryDataSelector } from '@/api/dictionary.js'
	import ConfirmOrder from '@/client/home/placeAnOrder/index.vue'
	export default {
		name: 'FbaDetailDialog',
		components: {
			ConfirmOrder

		},
		props: {
			isShow: {
				type: Boolean,
				default: false
			},
			direction: {
				type: String,
				default: 'rtl'
			},
			title: {
				type: String,
				default: '明细'
			},
			detail: {
				type: Object,
				default: {}
			}
		},
		data() {
			return {
				inputData: undefined,
				modeCodeOptions:[],
				confirmOrderVisible: false
			}
		},
		computed: {
			
		},
		watch: {},
		created() {},
		mounted() {},
		methods: {
			handleClose() {
				this.$emit('close', false)
			},
			getBusinessType(item) {
				switch (item.businessType) {
					case 1:
						return `Express`
					case 2:
						return `Air`
					case 3:
						return `Ocean`
					case 4:
						return `Ocean`
				}
			},
			getMode(data) {
				const targetData = this.modeCodeOptions.find(item => item.enCode === data.modeCodes);
				if(targetData){
					return targetData.fullName;
				}
				return ''
			},
			getUnit(countMode){
				switch(countMode){
					case 1:
					case 2:
						return 'KG'
					case 3:
						return 'CBM'
					default:
						return ''
				}
			},
			GetStartAddress(item) {
				switch (item.businessType) {
					case 1:
						return `${item.originZipcode},${item.originNameCn} `
					case 2:
						return `${item.startPortCode}`
					case 3:
						return `${item.OriginAddressCode}`
					case 4:
						return `${item.startPortCode}`
				}
			},
			GetDestAddress(item) {
				switch (item.businessType) {
					case 1:
						return `${item.destinationZipcode},${item.destinationName}`
					case 2:
						return `${item.destPortCode}`
					case 3:
						return `${item.DestinationAddressCode}`
					case 4:
						return `${item.destPortCode}`
				}
			},
			GetType(item) {
				switch (item.businessType) {
					case 2:
						switch (item.calculationType) {
							case 1:
								return `门到门`
							case 2:
								return `门到机场`
							case 3:
								return `机场到机场`
							case 4:
								return `机场到门`
						}
						break
					case 4:
						switch (item.calculationType) {
							case 1:
								return `门到门`
							case 2:
								return `门到港口`
							case 3:
								return `港口到港口`
							case 4:
								return `港口到门`
						}
						break
				}
				return ''
			},
			init(inputData){
				this.inputData = inputData
				getDictionaryDataSelector('fbaMode').then(res => {
					this.modeCodeOptions = res.data.list
				})
			},
			getChannelIcon(item){
				var businessName =  this.getMode(item);
				if(businessName){
					if(businessName.includes('快递')){
						return require('@/assets/img/client/check/ExpressDelivery.png')
					}else if(businessName.includes('铁路')){
						return require('@/assets/img/client/check/Railway.png')
					}else if(businessName.includes('空')){
						return require('@/assets/img/client/check/Air.png')
					}else if(businessName.includes('海')){
						return require('@/assets/img/client/check/Ocean.png')
					}
				}
			},
			closeConfirm() {
				this.confirmOrderVisible = false
			},
			openConfirm(orderNo, businessType) {
				this.confirmOrderVisible = true
				this.$nextTick(() => {
					this.$refs.ConfirmOrder.init(orderNo, businessType)
				})
			},
			toOrder(item) {
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)',
					customClass: 'is-loading-style'
				})
				this.handleClose()
				switch (item.businessType) {
					case 1: // 快递
						this.createExpOrder(item, loading)
						break
					case 2: // 空运
						this.createAirOrder(item, loading)
						break
					case 3: // fab
						this.createFbaOrder(item, loading)
						break
					case 4: // 海运
						this.createSeaOrder(item, loading)
						break
				}
			},
			createFbaOrder(item, loading) {
				var param = {
					isDraft: true,
					startCityId: this.inputData.OriginCityId,
					destCountryId: this.inputData.DestinationCountryId,
					storeCode: this.inputData.FbaWarehouseCode,
					quantity: this.inputData.TotalQuantity,
					weight: this.inputData.TotalWeight,
					volume: this.inputData.TotalVolume,
					channelId: item.channelId,
					totalValue: this.inputData.GoodsValue,
					buyInsurance: this.inputData.IsInsurance ? 1 : 0,
					productName: this.inputData.GoodsName,
					goodsReadyType: this.inputData.GoodsReadyType,
					goodsReadyTime: this.inputData.GoodsReadyTime,
					isKnowerShipper: this.inputData.IsKnown ? 1 : 0,
					isCustomsBrokerage: this.inputData.IsCustomsBrokerage ? 1 : 0,
					isBond: this.inputData.IsBond ? 1 : 0,
					bondType: this.inputData.BondType,
					isLiftgatePickup: this.inputData.IsLiftgatePickup ? 1 : 0,
					isLiftgateDelivery: this.inputData.IsLiftgateDelivery ? 1 : 0,
					cargoTypeIds: this.inputData.GoodsType
				}
				if (!this.inputData.FbaWarehouseCode) {
					param.addressType = 100
					param.consignee = {
						zipCode: this.inputData.DestinationZipCode,
						countryId: this.inputData.DestinationCountryId,
						cityName: this.inputData.DestinationAddressCode
					}
				}
				CreateFBAOrder(param).then(res => {
					loading.close()
					if (res.code === 200) {
						var orderNo = res.data
						this.openConfirm(orderNo, 3)
					}
				}).finally(() => {
					loading.close()
				})
			},
			createExpOrder(item, loading) {
				var param = {
					isDraft: true,
					startCityId: this.inputData.OriginCityId,
					destCityId: this.inputData.DestinationCityId,
					destCountryId: this.inputData.DestinationCountryId,
					quantity: this.inputData.TotalQuantity,
					weight: this.inputData.TotalWeight,
					volume: this.inputData.TotalVolume,
					channelId: item.channelId,
					cargoValue: this.inputData.GoodsValue,
					feeList: item.feeList,
					orderAmount: item.totalAmount,
					buyInsurance: this.inputData.IsInsurance ? 1 : 0,
					productName: this.inputData.GoodsName,
					goodsReadyType: this.inputData.GoodsReadyType,
					goodsReadyTime: this.inputData.GoodsReadyTime,
					isKnowerShipper: this.inputData.IsKnown ? 1 : 0,
					isLiftgatePickup: this.inputData.IsLiftgatePickup ? 1 : 0,
					totalValue: this.inputData.GoodsValue,
					destZipCode: this.inputData.DestinationZipCode,
					cargoTypeIds: this.inputData.GoodsType
				}
				CreateExpOrder(param).then((res) => {
					loading.close()
					if (res.code === 200) {
						var orderNo = res.data
						this.openConfirm(orderNo, 1)
					}
				}).finally(() => {
					loading.close()
				})
			},
			createAirOrder(item, loading) {
				var priceInfo = item.feeList.find((item) => item.name === 'AIR FREIGHT')
				var param = {
					airChannelId: item.channelId,
					airCompanyCode3: item.airCompanyCode3,
					destAirPortCode3: item.destPortCode,
					startAirPortCode3: item.startPortCode,
					weight: item.totalWeight,
					volume: item.totalVolume,
					quantity: item.totalQuantity,
					validTerm: item.workDays,
					airCompanyId: item.airCompanyId,
					airArrivalType: item.airArrivalType,
					orderServiceType: item.calculationType,
					planDeliveryTime: item.goodsReadTime,
					queryValidTime: item.expirationTime,
					orderTrafficAmount: priceInfo.amount,
					orderAmount: item.totalAmount,
					chargeWeight: priceInfo.units,
					costUnitPrice: priceInfo.unitPrice,
					goodsReadyType: this.inputData.GoodsReadyType,
					isKnowerShipper: this.inputData.IsKnown ? 1 : 0,
					buyInsurance: this.inputData.IsInsurance ? 1 : 0,
					goodsValue: this.inputData.GoodsValue,
					isCustomsBrokerage: this.inputData.IsCustomsBrokerage ? 1 : 0,
					isBond: this.inputData.IsBond ? 1 : 0,
					bondType: this.inputData.BondType,
					isLiftgatePickup: this.inputData.IsLiftgatePickup ? 1 : 0,
					isLiftgateDelivery: this.inputData.IsLiftgateDelivery ? 1 : 0,
					bondAmount: item.bondAmount,
					destLiftgateAmount: item.destLiftgateAmount,
					startLiftgateAmount: item.startLiftgateAmount,
					feeList: [
						...item.feeList.filter((item) => item.name !== 'AIR FREIGHT'),
						...item.destFeeList,
						...item.customsFeeList,
						...item.originFeeList
					],
					startCityId: item.originCityId,
					destCityId: item.destCityId,
					destCountryId: item.destinationCountryId,
					destSvcId: item.destSvcId,
					pickupAmount: item.pickupAmount,
					cargoIDs: this.inputData.GoodsType.join(',')
				}
				var deliveryInfo = item.destFeeList.find(
					(x) => x.name == 'AIR DELIVERY FREIGHT'
				)
				if (deliveryInfo != undefined) {
					param.deliveryAmount = deliveryInfo.amount
				}
				CreateAirOrder(param).then((res) => {
					loading.close()
					if (res.code === 200) {
						var orderNo = res.data
						this.openConfirm(orderNo, 2)
					}
				}).finally(() => {
					loading.close()
				})
			},
			createSeaOrder(item, loading) {
				var priceInfo = item.feeList.find((item) => item.name === 'SEA FREIGHT')
				var param = {
					shipPortCode: item.startPortCode,
					destPortCode: item.destPortCode,
					channelId: item.channelId,
					quantity: item.totalQuantity,
					weight: item.totalWeight,
					volume: item.totalVolume,
					orderAmount: item.amount,
					ServiceType: item.calculationType,
					planDeliveryTime: item.goodsReadTime,
					charge: priceInfo.units,
					unitPrice: priceInfo.unitPrice,
					costAmount: priceInfo.amount,
					totalAmount: item.totalAmount,
					workDays: item.workDays,
					goodsReadyType: this.inputData.GoodsReadyType,
					isKnowerShipper: this.inputData.IsKnown ? 1 : 0,
					buyInsurance: this.inputData.IsInsurance ? 1 : 0,
					priceEndDate: item.expirationTime,
					shipCompanyCode: item.modeCodes,
					goodsValue: this.inputData.GoodsValue,
					isCustomsBrokerage: this.inputData.IsCustomsBrokerage ? 1 : 0,
					isBond: this.inputData.IsBond ? 1 : 0,
					bondType: this.inputData.BondType,
					isLiftgatePickup: this.inputData.IsLiftgatePickup ? 1 : 0,
					isLiftgateDelivery: this.inputData.IsLiftgateDelivery ? 1 : 0,
					bondAmount: item.bondAmount,
					destLiftgateAmount: item.destLiftgateAmount,
					startLiftgateAmount: item.startLiftgateAmount,
					startCityId: item.originCityId,
					destCityId: item.destCityId,
					destCountryId: item.destinationCountryId,
					feeList: [
						...item.feeList.filter((item) => item.name !== 'SEA FREIGHT'),
						...item.destFeeList,
						...item.customsFeeList,
						...item.originFeeList
					],
					destSvcId: item.destSvcId,
					pickupAmount: item.pickupAmount
				}
				var deliveryInfo = item.destFeeList.find(
					(x) => x.name == 'SEA DELIVERY FREIGHT'
				)
				if (deliveryInfo != undefined) {
					param.deliveryAmount = deliveryInfo.amount
				}
				CreateSeaOrder(param).then((res) => {
					loading.close()
					if (res.code === 200) {
						var orderNo = res.data
						this.openConfirm(orderNo, 4)
					}
				}).finally(() => {
					loading.close()
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	.detail-dialog {
		& ::v-deep .el-drawer__wrapper {
			.el-drawer__header {
				height: 56px;
				padding: 0 24px;
				margin: 0;
				align-items: center;
				text-align: left;
				justify-content: space-between;
				border: 1px solid #ebebeb;
				box-sizing: border-box;

				span {
					display: inline-block;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 14px;
					color: #333333;
					line-height: 24px;
					text-align: left;
					font-style: normal;
				}

				.el-drawer__close-btn {
					font-size: 18px;
				}
			}
		}

		.card-remarks {
			width: 100%;
			height: 300px;
			margin: 16px;
			text-align: left;
			overflow-y: auto;

			.card-remarks-title{
				border-bottom: 1px solid #DDDDDD;
				display: flex;
				align-items: center;

				p{
					padding:10px 0 10px 10px;
					margin: 0;
				}

				div{
					border-radius: 10px;
					background-color: #477EFF;
					width: 4px;
					height: 16px;
				}
			}
		}

		.detail-dialog-main {
			padding: 16px 24px;
			box-sizing: border-box;

			.list-table-item {
				// width: 1200px;
				padding: 8px 0 ;
				display: flex;
				align-items: stretch;
				border-radius: 4px;
				transition: border 0.3s;
				box-sizing: border-box;

				.channel-icon{

				}

				// &:hover {
				//   border: 1px solid #3370ff;
				// }
				.list-table-item__left {
					flex: 1;
					padding: 0 16px;
					box-sizing: border-box;
					text-align: left;

					.filter-button1 {
						display: inline-block;
						min-width: 64px;
						min-height: 24px;
						padding: 3px 8px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						font-size: 12px;
						color: #3370ff;
						line-height: 17px;
						// text-align: center;
						font-style: normal;
						background: rgba(2, 127, 252, 0.08);
						border-radius: 8px 0px 8px 0px;
						box-sizing: border-box;
					}

					.tag-mode {
						font-size: 12px;
						background: #E5EDFF;
						border-radius: 6px 6px 6px 6px;
						border: 1px solid #3370FF;
						color: #3370FF;
						padding: 2px 5px;
						margin-left: 5px;
					}

					.tag-tax {
						font-size: 12px;
						background: #EFF8EA;
						border-radius: 6px 6px 6px 6px;
						border: 1px solid #34BE46;
						color: #34BE46;
						padding: 2px 5px;
						margin-left: 5px;
					}

					.channel-name-text {
						font-family: D, D;
						font-weight: normal;
						font-size: 14px;
						color: #333333;
						font-weight: bold;
						line-height: 16px;
						text-align: left;
						font-style: normal;
					}

					.recommendation {
						margin-left: 5px;
						color: #027ffc;
						font-weight: bold;
					}

					.text1 {
						font-family: D, D;
						font-weight: normal;
						font-size: 14px;
						color: #AAAAAA;
						line-height: 16px;
						text-align: left;
						font-style: normal;
					}

					.text2 {
						font-family: D, D;
						font-family: PingFangSC, PingFang SC;
						font-size: 15px;
						color: #000000;
						line-height: 16px;
						text-align: left;
						font-style: normal;
					}

					.line {
						width: 16px;
						height: 1px;
						background: #aaaaaa;
					}

					.inline-ask-btn {
						width: 96px;
						height: 32px;
						background: rgba(51, 112, 255, 0.04);
						border-radius: 8px;
						box-sizing: border-box;

						span {
							display: inline-block;
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							font-size: 13px;
							color: #3370ff;
							line-height: 18px;
							text-align: left;
							font-style: normal;
						}

						&:hover {
							cursor: pointer;
						}
					}

					.list-table-item__left-cargoTypeNames{
						align-items: center;
						div{
							display: -webkit-box;
							-webkit-line-clamp: 1;       /* 限制显示行数 */
							-webkit-box-orient: vertical;
							overflow: hidden;
							text-overflow: ellipsis;
						}
					}
				}

				.list-table-item__center {
					width: 256px;
					padding-right: 16px;
					box-sizing: border-box;
					display: flex;
					flex-direction: column;
					justify-content: center;

					.text1 {
						font-family: D-DINExp, D-DINExp;
						font-weight: bold;
						font-size: 20px;
						color: #333333;
						line-height: 22px;
						text-align: center;
						font-style: normal;

						&::after {
							position: relative;
							top: -8px;
							left: 3px;
							display: inline-block;
							font-family: D, D;
							font-weight: normal;
							font-size: 12px;
							color: #333333;
							line-height: 13px;
							text-align: left;
							font-style: normal;
						}
					}

					.text2 {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 13px;
						color: #aaaaaa;
						line-height: 18px;
						text-align: left;
						font-style: normal;
					}

					.text3 {
						font-family: D, D;
						font-weight: normal;
						font-size: 13px;
						color: #333333;
						line-height: 18px;
						text-align: left;
						font-style: normal;
					}

					.text4 {
						font-family: PingFangSC, PingFang SC;
						font-style: normal;
						color: #FF6C00;
						text-align: left;
						font-weight: 400;
						font-size: 24px;
					}
				}
				.list-table-item__toOrder{
					width: 220px;
					
					.choose-btn {
						outline: none;
						border: none;
						width: 200px;
						height: 50px;
						background: #3370ff;
						border-radius: 8px;
						box-sizing: border-box;

						span {
							display: inline-block;
							font-family: PingFangSC, PingFang SC;
							font-weight: 600;
							font-size: 14px;
							color: #ffffff;
							line-height: 20px;
							text-align: center;
							font-style: normal;
						}

						&:hover {
							cursor: pointer;
						}
					}

				}
			}

			.address-title {
				height: 40px;
				text-align: left;
				background: rgba(170, 170, 170, 0.08);
				box-sizing: border-box;

				span {
					display: inline-block;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 14px;
					color: #333333;
					line-height: 20px;
					text-align: left;
					font-style: normal;
				}
			}

			.detail-table {
				margin-top: 20px;
				width: 100%;
				border-collapse: collapse;
				box-sizing: border-box;

				.detail-table-tr {
					display: flex;
					align-items: center;

					.title {
						display: inline-block;
						font-family: PingFangSC, PingFang SC;
						font-weight: 550;
						font-size: 13px;
						color: #333333;
						font-style: normal;
					}

					.text {
						display: inline-block;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 13px;
						color: #333333;
						line-height: 18px;
						text-align: left;
						font-style: normal;
					}

					.text1 {
						display: inline-block;
						font-family: D-DINExp, D-DINExp;
						font-weight: bold;
						font-size: 13px;
						color: #333333;
						line-height: 14px;
						text-align: right;
						font-style: normal;
					}

					.text2 {
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						font-size: 13px;
						color: #333333;
						line-height: 18px;
						text-align: right;
						font-style: normal;
					}

					.text3 {
						display: inline-block;
						font-family: D-DINExp, D-DINExp;
						font-weight: bold;
						font-size: 16px;
						color: #333333;
						line-height: 17px;
						text-align: right;
						font-style: normal;
					}

					 .detail-table-td {
						border: 1px solid #EDEEEF;
						height: 55px;
						width: 100%;
						display: flex;
						align-items: center;
						justify-content: center;
						box-sizing: border-box;
					}

				}

				.detail-table-tr1 {
					border: none;

					.detail-table-td {
						text-align: right;
						width: 100% !important;
					}
				}

				.detail-table-tr2 {
					border: none;
					background: rgba(2, 127, 252, 0.08);

					.detail-table-td {
						padding: 11px 16px;
						text-align: right;
						width: 100% !important;
					}
				}
			}

			.detail-table-total{
				text-align: right;
				color: #000000;
				.text1{
					font-size: 14px;

				}
				.text2{
					font-size: 24px;
				}
				.text3{
					font-size: 24px;
					color: #FF6C00;
				}
			}

			.extra-charge-standards {
				text-align: left;

				.extra-charge-standards-title span:nth-child(1) {
					font-weight: bold;
				}
				
				.extra-charge-standards-table{
					border-collapse: collapse;
					width: 100%;
					text-align: center;
					border-color: #dddddd;
					.extra-charge-standards-table-tr{
						.extra-charge-standards-table-td{
							padding: 5px 0;
						}
						.extra-charge-standards-table-td:nth-child(1){
							width: 130px;
						}
						.extra-charge-standards-table-td:nth-child(2){
							width: 180px;
						}
					}
				}
				
				.card-remarks {
					height: 161px;
					background: rgba(0, 0, 0, 0.02);
					border-radius: 8px;
					margin: 16px;
					text-align: left;
					overflow-y: scroll;

					p {
						padding: 4px 8px;
						margin: 0;
					}

					span {
						padding: 0 8px;
						display: block;
					}
				}
				
			}

			.detail-tip {
				padding: 8px;
				background: rgba(0, 0, 0, 0.02);
				border-radius: 8px;
				box-sizing: border-box;

				.detail-tip-title {
					font-family: PingFangSC, PingFang SC;
					font-weight: 600;
					font-size: 13px;
					color: #333333;
					line-height: 18px;
					text-align: left;
					font-style: normal;
				}

				.detail-tip-text {
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 13px;
					color: #333333;
					line-height: 18px;
					text-align: left;
					font-style: normal;
				}
			}
		}
	}
</style>